// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickTextInput_textInputContainer__wXRCJ {
  --foreground-color: var(--foreground-color-1);
  --background-color: var(--background-color-1);
  --border-radius: 0.25rem;
  --border-size: 2px;
  --focus-color: var(--blackAlpha);
  color: var(--foreground-color);
}
.ClickTextInput_textInputContainer__wXRCJ.ClickTextInput_dark__N5vDo {
  --foreground-color: var(--background-color-1);
  --background-color: var(--foreground-color-1);
  --focus-color: var(--whiteAlpha);
}
.ClickTextInput_textInputContainer__wXRCJ .ClickTextInput_textInputWrapper__QxMHP {
  display: inline-block;
  width: 100%;
}
.ClickTextInput_textInputContainer__wXRCJ .ClickTextInput_textInputWrapper__QxMHP > .ClickTextInput_textInput__lW64z {
  font-size: 1em;
  border-radius: var(--border-radius);
  border: solid var(--border-size) var(--foreground-color);
  background: var(--background-color);
  color: var(--foreground-color);
  width: 100%;
  padding: 0.25em 0.5em;
}
.ClickTextInput_textInputContainer__wXRCJ .ClickTextInput_textInputWrapper__QxMHP > .ClickTextInput_textInput__lW64z::placeholder {
  color: var(--gray);
  font-style: italic;
}
.ClickTextInput_textInputContainer__wXRCJ .ClickTextInput_textInputWrapper__QxMHP > .ClickTextInput_textInput__lW64z.ClickTextInput_noStyle__c4rav {
  border: none;
  background: none;
}
.ClickTextInput_textInputContainer__wXRCJ .ClickTextInput_textInputWrapper__QxMHP > .ClickTextInput_textInput__lW64z.ClickTextInput_noStyle__c4rav:focus {
  outline: none;
}
.ClickTextInput_textInputContainer__wXRCJ .ClickTextInput_textInputWrapper__QxMHP > .ClickTextInput_textInput__lW64z.ClickTextInput_inlineStyle__M4pA8 {
  border: none;
  border-radius: 0;
  border-bottom: dashed var(--border-size) var(--gray);
  background: none;
}
.ClickTextInput_textInputContainer__wXRCJ .ClickTextInput_textInputWrapper__QxMHP > .ClickTextInput_textInput__lW64z:focus {
  outline: none;
  border-color: var(--blue);
}
.ClickTextInput_textInputContainer__wXRCJ label {
  font-weight: var(--bold);
}
.ClickTextInput_textInputContainer__wXRCJ .ClickTextInput_helpText__zoFZY {
  display: block;
  font-size: 0.75em;
  padding-bottom: 0.25em;
}

.ClickTextInput_errorMessage__8uaIu {
  font-size: 0.75em;
  color: var(--danger);
  min-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/ClickTextInput.module.scss"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,6CAAA;EACA,wBAAA;EACA,kBAAA;EACA,gCAAA;EAEA,8BAAA;AAAF;AAEE;EACE,6CAAA;EACA,6CAAA;EACA,gCAAA;AAAJ;AAEE;EACE,qBAAA;EACA,WAAA;AAAJ;AACI;EACE,cAAA;EACA,mCAAA;EACA,wDAAA;EACA,mCAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AACN;AAAM;EACE,kBAAA;EACA,kBAAA;AAER;AAAM;EACE,YAAA;EACA,gBAAA;AAER;AAAQ;EACE,aAAA;AAEV;AACM;EACE,YAAA;EACA,gBAAA;EACA,oDAAA;EACA,gBAAA;AACR;AACM;EACE,aAAA;EACA,yBAAA;AACR;AAIE;EACE,wBAAA;AAFJ;AAIE;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;AAFJ;;AAKA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AAFF","sourcesContent":[".textInputContainer {\n  --foreground-color: var(--foreground-color-1);\n  --background-color: var(--background-color-1);\n  --border-radius: 0.25rem;\n  --border-size: 2px;\n  --focus-color: var(--blackAlpha);\n\n  color: var(--foreground-color);\n\n  &.dark {\n    --foreground-color: var(--background-color-1);\n    --background-color: var(--foreground-color-1);\n    --focus-color: var(--whiteAlpha);\n  }\n  .textInputWrapper {\n    display: inline-block;\n    width: 100%;\n    > .textInput {\n      font-size: 1em;\n      border-radius: var(--border-radius);\n      border: solid var(--border-size) var(--foreground-color);\n      background: var(--background-color);\n      color: var(--foreground-color);\n      width: 100%;\n      padding: 0.25em 0.5em;\n      &::placeholder {\n        color: var(--gray);\n        font-style: italic;\n      }\n      &.noStyle {\n        border: none;\n        background: none;\n\n        &:focus {\n          outline: none;\n        }\n      }\n      &.inlineStyle {\n        border: none;\n        border-radius: 0;\n        border-bottom: dashed var(--border-size) var(--gray);\n        background: none;\n      }\n      &:focus {\n        outline: none;\n        border-color: var(--blue);\n      }\n    }\n  }\n\n  label {\n    font-weight: var(--bold);\n  }\n  .helpText {\n    display: block;\n    font-size: 0.75em;\n    padding-bottom: 0.25em;\n  }\n}\n.errorMessage {\n  font-size: 0.75em;\n  color: var(--danger);\n  min-height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textInputContainer": `ClickTextInput_textInputContainer__wXRCJ`,
	"dark": `ClickTextInput_dark__N5vDo`,
	"textInputWrapper": `ClickTextInput_textInputWrapper__QxMHP`,
	"textInput": `ClickTextInput_textInput__lW64z`,
	"noStyle": `ClickTextInput_noStyle__c4rav`,
	"inlineStyle": `ClickTextInput_inlineStyle__M4pA8`,
	"helpText": `ClickTextInput_helpText__zoFZY`,
	"errorMessage": `ClickTextInput_errorMessage__8uaIu`
};
export default ___CSS_LOADER_EXPORT___;
